module.exports = __webpack_public_path__ + "static/media/logo.9c16b082.png";